import { toast } from "react-toastify";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";
import {  GET_STATION_USAGE_FORECAST_API, } from "../../constants/constants";
import { fetchStationUsageForecastFailure, fetchStationUsageForecastSuccess, fetchStationUsageTrendFailure, fetchStationUsageTrendSuccess } from "./reducer";

export const getAllStationUsageForecast =
  (stationId, setLoading, dateRange) => async (dispatch) => {
    setLoading(true);
    const stepsMap = {
      "1m": 4,
      "3m": 12,
      "6m": 24,
      "12m": 52,
    };

    const payload = {
      forecast_type: "usage",
      unique_id: stationId,
      steps: stepsMap[dateRange?.period] || 90,
       frequency:"W"  // ← dynamic steps
    };
    const url = `${GET_STATION_USAGE_FORECAST_API}`;

    await determineBaseUrlAndPerformApiCall(url, "POST", payload)
      .then((response) => {
        setLoading(false);
        if (response === null || response === undefined) {
          dispatch(fetchStationUsageForecastSuccess([]));
          return;
        }


        if (!response.error) {
          dispatch(fetchStationUsageForecastSuccess(response || []));
        }

       if (response.error) {
  if (
    response.error.code === "NotFound" ||
    response.error.code === "ForecastFailed"  
  ) {
    dispatch(fetchStationUsageForecastSuccess([]));
  } else {
    dispatch(fetchStationUsageForecastFailure(response.error.message));
    toast.error(`${response.error.message}`);
  }
}
      })
      .catch((err) => {
        setLoading(false);
        console.error("Station Usage Forecast API Error >>>", err);
      });
  };
